<div class="bg-white p-xl-5 p-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-start" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 class="text-end text-secondary pb-2">Fiche récapitulative</h3>
  </div>
  <form *ngIf="form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      <div class="mb-3 row">
        <label class="col-sm-4 col-form-label required">Date de début</label>
        <div class="col-sm-8">
          <app-datepicker
            id="fieldBeginDate"
            formControlName="beginDate"
            [invalid]="submitted && (form.controls?.beginDate?.invalid || form.errors?.datesOrder)"
          ></app-datepicker>
          <small *ngIf="submitted && form.controls?.beginDate?.errors?.dateFormat" class="form-text text-danger"
            >La date de début est invalide.</small
          >
          <small *ngIf="submitted && form.controls?.beginDate?.errors?.required" class="form-text text-danger">La date de début est requise.</small>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-sm-4 col-form-label required">Date de fin</label>
        <div class="col-sm-8">
          <app-datepicker
            id="fieldEndDate"
            formControlName="endDate"
            [invalid]="submitted && (form.controls?.endDate?.invalid || form.errors?.datesOrder)"
          ></app-datepicker>
          <small *ngIf="submitted && form.controls?.endDate?.errors?.dateFormat" class="form-text text-danger">La date de fin est invalide.</small>
          <small *ngIf="submitted && form.controls?.endDate?.errors?.required" class="form-text text-danger">La date de fin est requise.</small>
          <small *ngIf="submitted && form.errors?.datesOrder" class="form-text text-danger"
            >La date de début est incohérente avec la date de fin.</small
          >
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-sm-4 col-form-label required">Structure</label>
        <div class="col-sm-8">
          <select class="form-select" formControlName="structureId" [class.is-invalid]="submitted && form.controls?.structureId?.errors?.required">
            <option *ngFor="let structure of structures" [ngValue]="structure.id" [disabled]="!structure.active">
              {{ structure.label }}
            </option>
          </select>
          <small *ngIf="submitted && form.controls?.structureId?.errors?.required" class="form-text text-danger">La structure est obligatoire.</small>
        </div>
      </div>
      <div class="mb-3 row">
        <label for="support-type" class="col-sm-4 col-form-label">Type d'accompagnement</label>
        <div class="mb-3 text-secondary col-sm-8">
          <ng-select
            id="support-type"
            formControlName="supportTypeIds"
            [items]="supportTypes"
            bindValue="id"
            [multiple]="true"
            [closeOnSelect]="false"
            groupBy="category"
            [selectableGroup]="true"
            [selectableGroupAsModel]="false"
            [class.is-invalid]="submitted && form.controls.supportTypeIds.invalid"
          ></ng-select>
        </div>
      </div>
    </div>
    <div class="row px-3">
      <div class="d-grid ms-lg-auto col-3 col-md-6 col-lg-3 mb-1">
        <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="cancel()">
          <fa-icon icon="ban"></fa-icon>
          <span class="ms-3 d-none d-md-block">Annuler</span>
        </button>
      </div>
      <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
        <button class="btn btn-primary d-flex justify-content-center" type="submit">
          <fa-icon icon="download"></fa-icon>
          <span class="ms-3 d-none d-md-block">Générer</span>
        </button>
      </div>
    </div>
  </form>
</div>
